/**
 * @file
 * Provide a jQuery plugin to create modal windows dynamically.
 *
 * The function accepts a title as only parameter and can be applied to any
 * jQuery object, which then gets appended as modal content. The new modal
 * component is returned as jQuery object and appears immediately. It can be
 * closed by clicking on the background or elements with the class 'js-modal-close'.
 *
 * e.g. let $filterModal = $filterForm.createModal(Drupal.t('Filter results'));
 */

(function ($, Drupal) {
  $.fn.createModal = function (title) {
    // Prepare modal component
    let $modal = $('<aside/>').addClass('modal');
    let $modalWrapper = $('<div/>').addClass('modal__wrapper').appendTo($modal);
    let $modalContainer = $('<div/>').addClass('modal__container').appendTo($modalWrapper);

    // Add headline and content
    $('<h2/>').addClass('modal__title').text(title).appendTo($modalContainer);
    this.appendTo($modalContainer);

    // Add close button
    let closeIconSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/></svg>';
    let $modalCloseButton = $('<button/>').addClass('modal__close js-modal-close').attr('type', 'button').attr('title', Drupal.t('Close')).appendTo($modalContainer);
    $('<span/>').addClass('icon-svg icon-svg--large').append(closeIconSVG).appendTo($modalCloseButton);

    // Prevent body scrolling while modal is open
    $('body').addClass('is-locked').append($modal);

    $modal.addClass('is-open-modal');

    if ($modal.hasClass('is-open-modal')) {
      setTimeout(function(){
        $(document).on('click', removeModal);
      }, 1);
    }

    function removeModal(event) {
      // Check if click occurred on close element or outside of modal container.
      const $targetParentBack = $(event.target).parents().addBack();
      if (!$targetParentBack.is('.select2-search') && ($targetParentBack.is('.js-modal-close') || !$targetParentBack.is($modalContainer))) {
        if (!$targetParentBack.is('.ui-menu')) {
          // Allow body scrolling again
          $('body').removeClass('is-locked');

          // Hide and remove modal
          $modal.removeClass('is-open-modal').addClass('is-closed-modal');
          $(document).on('click', removeModal);

          setTimeout(function(){
            $modal.remove();
          }, 300);

          // Stop listening for additional click events
          $(document).off('click', removeModal);
        }
      }
    }

    // Trigger js-behaviors
    Drupal.attachBehaviors(document, Drupal.settings);

    return $modal;
  };
})(jQuery, Drupal);
